import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { User_Permissions, login_success } from '../../actions/user';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import { Link } from 'react-router-dom';
import './style.scss';
import AuthLayout from '../../components/AuthLayout';

const Login = () => {
  const history = useNavigate();
  const user = useSelector((state: any) => state.user)
  useEffect(() => {
    if (user && localStorage.getItem('CRA_auth_token')) {
      history('/dashboard')
    }
  }, [])

  const dispatch = useDispatch();
  const [username, setUsername] = useState('');
  const [remember, setRemember] = useState(false);
  const [password, setPassword] = useState('');
  const [eyes, setEyes] = useState({ password: false, confirmPassword: false, currentPassword: false });
  const [step, setStep] = useState(1);
  const [otp, setOTP] = useState('');
  const [resp, setRes]: any = useState();
  const [ip, setIp]: any = useState();

  useEffect(() => {
    loader(true)
    setTimeout(() => {
      loader(false)
    }, 500);
    let r = localStorage.getItem('remember')
    if (r) {
      let data = JSON.parse(r)
      setUsername(data.email)
      setPassword(data.password)
      setRemember(true)
    }

    // Using an HTTP GET request to ipinfo.io/json

    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        let ip = data.ip
        localStorage.setItem('IP', ip)
        setIp(ip)
      })
      .catch(error => console.error('Error fetching IP address:', error));
  }, [])

  const setLogin = (data: any) => {
    localStorage.setItem('CRA_auth_token', data.access_token)
    dispatch(login_success(data))
    let url = '/dashboard'
    history(url);
  }

  const hendleSubmit = (e: any) => {
    e.preventDefault()
    let data: any = {
      email: username,
      password
    };

    let url = 'admin/login'


    loader(true)
    ApiClient.post(url, data).then(res => {
      loader(false)
      if (res.success == true) {
        localStorage.setItem('userID', res?.data?.id)
        if (remember) {
          localStorage.setItem('remember', JSON.stringify(data))
        } else {
          localStorage.removeItem('remember')
        }
        if (res?.data?.role == 'subadmin' || res?.data?.roleDetail == 'subadmin') {
          ApiClient.get('permission/user-base', { user_id: res?.data?.id }).then((resp) => {
            if (resp?.success) {
              localStorage.setItem('items', JSON.stringify(resp?.data))
              // const items = JSON.parse(localStorage.getItem(resp?.data));
              // console.log(items)
              dispatch(User_Permissions(resp?.data))
              localStorage.setItem("permission", JSON.stringify(resp?.data))

            }
          });


        }
        dispatch(login_success(res?.data))

        history('/dashboard')

        setLogin(res?.data)


      }
    })
  };
  return (
    <>

      <AuthLayout>
        <form className="" onSubmit={hendleSubmit}>
          <h4 className="text-typo mb-6 text-2xl font-bold">Sign in</h4>
          {step == 1 ? <>
            <input
              type="email"
              className="bg-white mb-6 w-full text-sm placeholder:text-gray-500 h-10 flex items-center gap-2 overflow-hidden px-2 !ring-primary !outline-primary"
              placeholder="Email address"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <div className="relative mb-6">
              <input
                type={eyes.password ? "text" : "password"}
                className="bg-white w-full text-sm placeholder:text-gray-500 h-10 flex items-center gap-2 overflow-hidden px-2 !ring-primary !outline-primary"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                required
              />
              {eyes.password ? (
                <i
                  className="fa fa-eye top-3 right-3 absolute text-gray-600"
                  onClick={() =>
                    setEyes({ ...eyes, password: !eyes.password })
                  }
                />
              ) : (
                <i
                  className="fa fa-eye-slash top-3 right-3 absolute text-gray-600"
                  onClick={() =>
                    setEyes({ ...eyes, password: !eyes.password })
                  }
                />
              )}
            </div>
          </> : <>
            <p className="mb-2">OTP sent on email</p>
            <input
              type="text"
              maxLength={6}
              minLength={6}
              className="bg-white mb-6 w-full text-sm placeholder:text-gray-500 h-10 flex items-center gap-2 overflow-hidden px-2 !ring-primary !outline-primary"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOTP(e.target.value)}
              required
            />
          </>}
          <div className='flex'>
            <label className='flex items-center pointer'><input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="mr-2 h-4 w-4" /> <span className='text-md text-gray-600'>Remember Me</span></label>
            <Link className="sign_up ml-auto" to="/forgotpassword"> Forgot Password</Link>
          </div>


          <div className="mt-8">
            <button type="submit" className="px-4 w-full text-sm font-normal text-white h-12 flex items-center justify-center gap-2 shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed">Sign in</button>
          </div>

          <p className='accopuntt'></p>
        </form>
      </AuthLayout>
    </>
  );
};

export default Login;